import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  House, Users, Trophy, Lightning, FloppyDisk, ChartBar, Crown,
  GameController, Globe, GlobeHemisphereWest, Flag, SoccerBall, SignOut, Lock, Star,
} from '@phosphor-icons/react';
import { JwflLogo } from './EwflLogo';
import { AudioToggle } from './AudioToggle';

const navItems = [
  { path: '/', label: 'Home', icon: House, testid: 'home' },
  { path: '/play-now', label: 'Play', icon: Lightning, testid: 'play' },
  { path: '/league', label: 'League', icon: Trophy, testid: 'league' },
  { path: '/cup', label: 'Cup', icon: GameController, testid: 'cup' },
  { path: '/asian-cup', label: 'Asian Cup', icon: Globe, testid: 'asian-cup' },
  { path: '/club-world-cup', label: 'CWC', icon: Flag, testid: 'cwc' },
  { path: '/world-cup', label: 'WC', icon: GlobeHemisphereWest, testid: 'wc' },
  { path: '/manager', label: 'Glory', icon: Crown, testid: 'glory' },
  { path: '/player-career', label: 'Career', icon: SoccerBall, testid: 'career' },
  { path: '/blue-lock', label: 'Blue Lock', icon: Lock, testid: 'bluelock', locked: true },
  { path: '/teams', label: 'Teams', icon: Users, testid: 'teams' },
  { path: '/stats', label: 'Stats', icon: ChartBar, testid: 'stats' },
  { path: '/credits', label: 'Credits', icon: Star, testid: 'credits' },
];

export const Navigation = ({ user, onLogout }) => {
  const location = useLocation();

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 backdrop-blur-md border-b"
      style={{
        background: 'rgba(4,6,15,0.92)',
        borderColor: 'rgba(0,229,255,0.18)',
        boxShadow: '0 1px 0 rgba(0,229,255,0.10), 0 8px 24px rgba(0,0,0,0.5)',
      }}
    >
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between h-14">
          <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
            <JwflLogo size={36} showWordmark wordmarkClass="text-lg hidden sm:block" />
          </Link>

          <div className="flex items-center gap-0.5 overflow-x-auto">
            {navItems.map(({ path, label, icon: Icon, testid, locked }) => {
              const isActive = location.pathname === path
                || (path === '/player-career' && location.pathname.startsWith('/player-career'));
              return (
                <Link
                  key={path}
                  to={path}
                  data-testid={`nav-${testid}`}
                  className={`flex items-center gap-1.5 px-2 py-1.5 text-[11px] whitespace-nowrap font-medium transition-all duration-150 rounded-sm relative
                    ${isActive
                      ? 'text-white'
                      : locked
                        ? 'text-[#5A6390] hover:text-[#FFB400]'
                        : 'text-[#7A86B5] hover:text-white'}`}
                  style={isActive ? {
                    background: 'rgba(0,229,255,0.08)',
                    borderBottom: '2px solid #00E5FF',
                    boxShadow: 'inset 0 -8px 16px rgba(0,229,255,0.10)',
                  } : undefined}
                >
                  <Icon size={14} weight={isActive ? 'fill' : 'regular'} />
                  <span className="hidden md:inline">{label}</span>
                  {locked && (
                    <span className="hidden md:inline-flex items-center text-[8px] font-bold tracking-[0.12em] px-1 py-px rounded-sm uppercase ml-0.5"
                      style={{ color: '#FFB400', borderColor: '#FFB400', border: '1px solid rgba(255,180,0,0.6)' }}>
                      ◆
                    </span>
                  )}
                </Link>
              );
            })}
          </div>

          <div className="flex items-center gap-2">
            <AudioToggle />
            {user && (
              <>
                <span className="text-xs text-[#7A86B5] hidden sm:inline">{user.name || user.email}</span>
                <button onClick={onLogout}
                  className="flex items-center gap-1 text-[#7A86B5] hover:text-[#FF006E] transition-colors text-xs"
                  data-testid="logout-btn">
                  <SignOut size={16} />
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};
